import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Tooltip,
  useMediaQuery
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { exportToExcel, fAlertToast } from '../../../Utility/Utilitys';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { DataGridPro } from '@mui/x-data-grid-pro';
import {
  distributionItemVarianceApi,
  distributionVANItemSaveApi,
  itemDistributionApi
} from '../../Purchase/actions';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import moment from 'moment';
import { confirmAlert } from 'react-confirm-alert';
import { useSelector } from 'react-redux';
import { CmpTypographyField } from '../../../component/ToolBox/ToolBox';

const toolbar = {
  backgroundColor: '#0d73bb',
  color: 'white',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '40px !important'
};

export const ItemvarianceModal = ({ data, open, onClose, cardData }) => {
  const [varianceData, setVarianceData] = useState([]);

  useEffect(() => {
    if (open) {
      fvariance();
    }
  }, [open, cardData]);
  const fvariance = async () => {
    const obj = {
      VocTyp: data?.A_VocTyp,
      VocNo: data?.A_VocNo,
      Truck: data?.TruckID
    };

    const result = await distributionItemVarianceApi(obj);
    console.log(result);

    if (result?.Type === 'Success') {
      if (result?.ResultSet?.VarianceRows.length > 0) {
        const records = result?.ResultSet?.VarianceRows || [];
        setVarianceData(records);
        console.log(records);
      } else {
        setVarianceData([]); // optional: clear if no records
      }
    } else {
      console.error('API Error:', result);
    }
  };

  const columns = [
    {
      field: 'ItmCd',
      headerName: 'ItmCd ',
      width: 100,
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      flex: 1
    },
    { field: 'ItemName', headerName: 'Item Name', width: 200 },
    {
      field: 'UnitName',
      headerName: 'UnitName ',
      width: 100,
      type: 'number',
      align: 'left',
      headerAlign: 'left',
      flex: 1
    },
    {
      field: 'Distri_Qty',
      headerName: 'Distribution Qty ',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      flex: 1
    },

    {
      field: 'Items_Qty',
      headerName: ' GRN Qty',
      width: 100,
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1
    },

    {
      field: 'Variance',
      headerName: ' Variance',
      width: 100,
      type: 'number',
      align: 'center',
      headerAlign: 'center',
      flex: 1
    }
  ];

  const fClose = () => {
    setVarianceData([]);
    onClose();
  };
  const handleExport = () => {
    exportToExcel(varianceData, 'ItemList_data', 'ItemList');
  };

  return (
    <Dialog open={open} onClose={fClose} maxWidth="lg">
      <Toolbar sx={toolbar}>
        <DialogTitle
          sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0 4px !important' }}>
          Variance
        </DialogTitle>
        <IconButton edge="end" color="inherit" onClick={fClose} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <DialogContent sx={{ '&.MuiDialogContent-root': { padding: '10px !important' } }}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={3} sm={2.5} md={2.5}>
                <CmpTypographyField xcomponent={'span'} xText={'Voucher Type'} />
              </Grid>

              <Grid item xs={0.5} sm={0.5} md={0.5}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>

              <Grid item xs={8.5} sm={9} md={9}>
                <CmpTypographyField
                  xcomponent={'span'}
                  xText={`${data?.A_VocTyp} - ${data?.VocName}`}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={3} sm={2.5} md={2.5}>
                <CmpTypographyField xcomponent={'span'} xText={'Voucher'} />
              </Grid>
              <Grid item xs={0.5} sm={0.5} md={0.5}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={8.5} sm={9} md={9}>
                <CmpTypographyField xcomponent={'span'} xText={`${data?.A_VocNo}`} />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={3} sm={2.5} md={2.5}>
                <CmpTypographyField xcomponent={'span'} xText={'Location'} />
              </Grid>
              <Grid item xs={0.5} sm={0.5} md={0.5}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={8.5} sm={9} md={9}>
                <CmpTypographyField xcomponent={'span'} xText={data?.LocName} />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              sx={{ alignItems: 'center' }}>
              <Grid item xs={3} sm={2.5} md={2.5}>
                <CmpTypographyField xcomponent={'span'} xText={'Truck'} />
              </Grid>
              <Grid item xs={0.5} sm={0.5} md={0.5}>
                <CmpTypographyField xcomponent={'span'} xText={':'} />
              </Grid>
              <Grid item xs={8.5} sm={9} md={8.5}>
                <CmpTypographyField xcomponent={'span'} xText={data?.TruckName} />
              </Grid>
              <Grid item xs={1} sm={1} md={0.5} mt={0.6}>
                <Tooltip title="Export">
                  <IconButton
                    color="primary"
                    onClick={handleExport}
                    size="small"
                    sx={{
                      padding: 0,
                      '& .MuiSvgIcon-root': {
                        fontSize: '20px'
                      }
                    }}>
                    <DownloadOutlinedIcon />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Box />

        <Grid item xs={12} sm={12} md={12} lg={12} mt={1}>
          <Box
            sx={{
              height: '55vh',
              width: '100%'
            }}>
            <DataGridPro
              className="gridTable"
              rowHeight={30}
              headerHeight={30}
              rows={varianceData}
              columns={columns}
              getRowId={(row) => row.id}
              disableRowSelectionOnClick
              hideFooter
              disableSelectionOnClick
            />
          </Box>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};
